module.exports = __webpack_public_path__ + "static/media/craft_sold_item_first.bcc36401.mp3";